import LayoutFour from "pages/User/LayoutFour/index.page";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.LAYOUTFOUR.path,
      name: "LAYOUTFOUR",
      key: routesMap.LAYOUTFOUR.path,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <LayoutFour />,
    },
    {
      path: `${routesMap.LAYOUTFOUR.path}/:id`,
      name: "LAYOUTFOUR",
      key: `${routesMap.LAYOUTFOUR.path}/:id`,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <LayoutFour />,
    },
  ];
}
